
const setLocalstorage = (status) => {
    localStorage.setItem("cnapp", status);
}
const getLocalstorage = () => {
    let conection = true;
    let valueStorage = localStorage.getItem("cnapp");
    if (valueStorage) {
        conection = JSON.parse(valueStorage);
    }
    return conection;
}

const getUsers = async (db) => {
    return new Promise((resolve, reject) => {
        try {

            let trans = db.transaction(['users'], 'readonly');
            trans.oncomplete = e => {
                console.log(e ? '' : '');
                resolve(users);
            };
            let store = trans.objectStore('users');
            let users = [];

            store.openCursor().onsuccess = e => {
                let cursor = e.target.result;
                if (cursor) {
                    let data = cursor.value;
                    data.indexedDBId = cursor.primaryKey;
                    users.push(data)
                    cursor.continue();
                }
            };
        } catch (error) {
            reject(error)
        }


    });
}

const getEventSelecteds = async (db) => {
    return new Promise((resolve, reject) => {
        try {
            let trans = db.transaction(['eventselected'], 'readonly');
            trans.oncomplete = e => {
                console.log(e ? '' : '');
                resolve(eventSelecteds);
            };
            let store = trans.objectStore('eventselected');
            let eventSelecteds = [];
            store.openCursor().onsuccess = e => {
                let cursor = e.target.result;
                if (cursor) {
                    let data = cursor.value;
                    data.indexedDBId = cursor.primaryKey;
                    eventSelecteds.push(data)
                    cursor.continue();
                }
            };
        } catch (error) {
            reject(error)
        }
    });
}

const closeSession = (db) => {
    return new Promise(async (resolve, reject) => {
        try {


            let users = await getUsers(db);
            if (users && users.length > 0) {
                for (let user of users) {
                    let trans = db.transaction(['users'], 'readwrite');
                    let store = trans.objectStore('users').delete(user.indexedDBId);
                    trans.oncomplete = () => {

                    }
                }
                resolve({});
            } else {
                resolve({});
            }


            let eventSelecteds = await getEventSelecteds(db);
            if (eventSelecteds && eventSelecteds.length > 0) {
                for(let event of eventSelecteds ){
                    let trans = db.transaction(['eventselected'], 'readwrite');
                    let store = trans.objectStore('eventselected').delete(event.indexedDBId);
                    trans.oncomplete = () => {
                    } 
                }
                resolve({});
            } else {
                resolve({});
            }

        } catch (error) {
            reject(error)
        }
    });
}

const getEvents = async (db) => {
    return new Promise((resolve, reject) => {
        try {
            let trans = db.transaction(['events'], 'readonly');
            trans.oncomplete = e => {
                console.log(e ? '' : '');
                resolve(events);
            };
            let store = trans.objectStore('events');
            let events = [];

            store.openCursor().onsuccess = e => {
                let cursor = e.target.result;
                if (cursor) {
                    let data = cursor.value;
                    data.indexedDBId = cursor.primaryKey;
                    events.push(data)
                    cursor.continue();
                }
            };
        } catch (error) {
            reject(error)
        }
    });
}

export default {
    getDb: () => {
        return new Promise((resolve, reject) => {
            let request = window.indexedDB.open("registronuevoaccessocontrol", 2);
            request.onerror = e => {
                reject('Error');
            };
            request.onsuccess = e => {
                resolve(e.target.result);
            };
            request.onupgradeneeded = e => {
                console.log('onupgradeneeded');
                let db = e.target.result;
                // let objectStore = db.createObjectStore("assistantsQr", { autoIncrement: true, keyPath: 'id' });
                let objectStore2 = db.createObjectStore("users", { autoIncrement: true, keyPath: 'id' });
                // let objectStore3 = db.createObjectStore("events", { autoIncrement: true, keyPath: 'id' });
                let objectStore4 = db.createObjectStore("eventselected", { autoIncrement: true, keyPath: 'id' });
                console.log(objectStore2, objectStore4)
            };
        });
    },
    addAssistant: async (assistant, db) => {
        let trans = db.transaction(['assistantsQr'], 'readwrite');
        trans.oncomplete = e => {
            console.log(e)
        };
        let store = trans.objectStore('assistantsQr');
        store.add(assistant);
    },
    addUser: async (user, db) => {
        console.log('about to add ' + JSON.stringify(user));
        let trans = db.transaction(['users'], 'readwrite');
        trans.oncomplete = e => {
            console.log(e)
        };
        let store = trans.objectStore('users');
        store.add(user);
    },

    addEventSelected: async (event, db) => {
        console.log('about to add ' + JSON.stringify(event));
        let trans = db.transaction(['eventselected'], 'readwrite');
        trans.oncomplete = e => {
            console.log(e)
        };
        let store = trans.objectStore('eventselected');
        store.add(event);
    },

    getPerson: async (db, eventId) => {
        return new Promise((resolve, reject) => {
            try {
                let trans = db.transaction(['assistantsQr'], 'readonly');
                trans.oncomplete = e => {
                    persons = persons.filter(v => v.eventId == eventId);
                    resolve(persons);
                };
                let store = trans.objectStore('assistantsQr');
                let persons = [];

                store.openCursor().onsuccess = e => {
                    let cursor = e.target.result;
                    if (cursor) {
                        let data = cursor.value;
                        data.indexedDBId = cursor.primaryKey;
                        persons.push(data)
                        cursor.continue();
                    }
                };
            } catch (error) {
                reject(error)
            }

        });
    },
    addEvents: async (events, db) => {
        for (let event of events) {
            let trans = db.transaction(['events'], 'readwrite');
            trans.oncomplete = e => {
                console.log(e)
            };
            let store = trans.objectStore('events');
            store.add(event);
        }

    },
    updatePerson: async (db, indexedDBId, data) => {
        return new Promise((resolve, reject) => {
            try {
                let trans = db.transaction(['assistantsQr'], 'readwrite');
                let store = trans.objectStore('assistantsQr');

                store.openCursor().onsuccess = e => {
                    let cursor = e.target.result;
                    if (cursor) {
                        if (cursor.key == indexedDBId) {
                            const invoice = cursor.value;
                            for (let prop in data) {
                                invoice[prop] = data[prop]
                            }
                            const updateRequest = cursor.update(invoice);
                        }
                        cursor.continue();
                    }
                };

                resolve({})
            } catch (error) {
                reject(error)
            }

        });
    },
    updateEvent: async (db, indexedDBId, data) => {
        return new Promise((resolve, reject) => {
            try {
                let trans = db.transaction(['events'], 'readwrite');
                let store = trans.objectStore('events');
                store.openCursor().onsuccess = e => {
                    let cursor = e.target.result;
                    if (cursor) {
                        if (cursor.key == indexedDBId) {
                            const invoice = cursor.value;
                            for (let prop in data) {
                                invoice[prop] = data[prop]
                            }
                            const updateRequest = cursor.update(invoice);
                        }
                        cursor.continue();
                    }
                };
                resolve({})
            } catch (error) {
                reject(error)
            }

        });
    },
    setLocalstorage,
    getLocalstorage,
    closeSession,
    getUsers,
    getEvents,
    getEventSelecteds
}